import axiosHttp from "./interceptor.service";

const getAdminDashBoard = ({ month, year } = {}) => {
  return axiosHttp.get("/lmt/getDashboard", { params: { month, year } });
};

const getClientDashBoard = (id, { month, year }) => {
  return axiosHttp.get(`/lmt/getClientDashboard/${id}`, {
    params: { month, year },
  });
};

const getTaskOverview = ({ month, year } = {}) => {
  return axiosHttp.get("/lmt/getTaskOverview", { params: { month, year } });
};

export { getAdminDashBoard, getClientDashBoard, getTaskOverview };
